/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { organizationRoleIdGet } from '../fn/organization-role/organization-role-id-get';
import { OrganizationRoleIdGet$Params } from '../fn/organization-role/organization-role-id-get';
import { OrganizationRoleModel } from '../models/organization-role-model';
import { OrganizationRoleModelSearchResultModel } from '../models/organization-role-model-search-result-model';
import { organizationRolePost } from '../fn/organization-role/organization-role-post';
import { OrganizationRolePost$Params } from '../fn/organization-role/organization-role-post';
import { organizationRoleSearchOrganizationRolePost } from '../fn/organization-role/organization-role-search-organization-role-post';
import { OrganizationRoleSearchOrganizationRolePost$Params } from '../fn/organization-role/organization-role-search-organization-role-post';

@Injectable({ providedIn: 'root' })
export class MDIOrganizationRoleService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `organizationRoleSearchOrganizationRolePost()` */
  static readonly OrganizationRoleSearchOrganizationRolePostPath = '/OrganizationRole/SearchOrganizationRole';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationRoleSearchOrganizationRolePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationRoleSearchOrganizationRolePost$Response(params?: OrganizationRoleSearchOrganizationRolePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<OrganizationRoleModelSearchResultModel>> {
    return organizationRoleSearchOrganizationRolePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationRoleSearchOrganizationRolePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationRoleSearchOrganizationRolePost(params?: OrganizationRoleSearchOrganizationRolePost$Params, context?: HttpContext): Observable<OrganizationRoleModelSearchResultModel> {
    return this.organizationRoleSearchOrganizationRolePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<OrganizationRoleModelSearchResultModel>): OrganizationRoleModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `organizationRoleIdGet()` */
  static readonly OrganizationRoleIdGetPath = '/OrganizationRole/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationRoleIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationRoleIdGet$Response(params: OrganizationRoleIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<OrganizationRoleModel>> {
    return organizationRoleIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationRoleIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationRoleIdGet(params: OrganizationRoleIdGet$Params, context?: HttpContext): Observable<OrganizationRoleModel> {
    return this.organizationRoleIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<OrganizationRoleModel>): OrganizationRoleModel => r.body)
    );
  }

  /** Path part for operation `organizationRolePost()` */
  static readonly OrganizationRolePostPath = '/OrganizationRole';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationRolePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationRolePost$Response(params?: OrganizationRolePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return organizationRolePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationRolePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationRolePost(params?: OrganizationRolePost$Params, context?: HttpContext): Observable<string> {
    return this.organizationRolePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
